import { render, staticRenderFns } from "./MotdEdit.vue?vue&type=template&id=0919d8f6&"
import script from "./MotdEdit.vue?vue&type=script&lang=ts&"
export * from "./MotdEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0919d8f6')) {
      api.createRecord('0919d8f6', component.options)
    } else {
      api.reload('0919d8f6', component.options)
    }
    module.hot.accept("./MotdEdit.vue?vue&type=template&id=0919d8f6&", function () {
      api.rerender('0919d8f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MotdEdit.vue"
export default component.exports